// Keeps the theme's cart in step with adds made from the "Mst: Wishlist Prime" drawer.
//
// The app posts to /cart/add itself and never tells the theme about it, so Dawn's cart drawer and
// the header count keep their server-rendered markup until the next page load — the product looks
// like it was never added. Adds are detected on the drawer's own buttons, the cart is polled until
// the server confirms the change, then the cart sections are re-rendered in place and cart-update is
// published so the rest of the theme follows.
//
// Section rendering is used rather than cart-drawer's renderContents(): that method also opens the
// cart drawer, which would slide over the wishlist drawer the shopper is still using.
if (!window.themeWishlistCartSync) {
  window.themeWishlistCartSync = true;

  const TRIGGER_SELECTOR = '#iwish-drawer-root .add_to_cart, #iwish-drawer-root .addToCart-btn';
  const POLL_INTERVAL = 400;
  const POLL_TIMEOUT = 8000;

  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const fetchCart = async () => {
    const response = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`cart.js responded ${response.status}`);
    return response.json();
  };

  // The app fires its request after this click handler runs, so the poll compares against the cart
  // as it was at click time and stops as soon as the server reports something different.
  const waitForCartChange = async (baseline) => {
    const deadline = Date.now() + POLL_TIMEOUT;

    while (Date.now() < deadline) {
      await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL));

      try {
        const cart = await fetchCart();
        const changed = cart.item_count !== baseline.item_count || cart.updated_at !== baseline.updated_at;
        if (changed) return cart;
      } catch (error) {
        return null;
      }
    }

    return null;
  };

  const sectionInnerHTML = (html, selector) => {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  };

  const renderCartSections = async () => {
    const response = await fetch(`${rootUrl()}?sections=cart-drawer,cart-icon-bubble`);
    if (!response.ok) return;
    const sections = await response.json();

    const drawer = document.getElementById('CartDrawer');
    if (drawer && sections['cart-drawer']) {
      const markup = sectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      if (markup !== null) {
        drawer.innerHTML = markup;
        // The drawer's empty state is a class on the custom element, not on the section markup.
        const cartDrawer = drawer.closest('cart-drawer');
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (cartDrawer && overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const markup = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (markup !== null) bubble.innerHTML = markup;
    }
  };

  // The header cart count is this theme's own markup, not Dawn's bubble, so it is set from the cart
  // payload directly — the section swap above only covers stores still using the Dawn element.
  const renderCartCount = (cart) => {
    const count = cart.item_count;
    document.querySelectorAll('.site-header__cart-count').forEach((element) => {
      element.textContent = count < 100 ? count : '99+';
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.classList.toggle('is-empty', count === 0);
  };

  const onTriggerClick = async (event) => {
    if (!event.target.closest(TRIGGER_SELECTOR)) return;

    let baseline;
    try {
      baseline = await fetchCart();
    } catch (error) {
      return;
    }

    const cart = await waitForCartChange(baseline);
    if (!cart) return;

    renderCartCount(cart);
    await renderCartSections();

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist-drawer', cartData: cart });
    }
  };

  document.addEventListener('click', onTriggerClick);
}
